// extracted by mini-css-extract-plugin
export default {"menuButton":"ClassroomModal_menuButton__wdk3v"};